import React from 'react';
import PropTypes from 'prop-types';
import colors from '@bnnvara/themes';

const Close = ({
  color,
  size,
  bold
}) => {
  const strokeWidth = bold ? '3.5' : '1';
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 25 25",
    "aria-label": "sluiten"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    strokeWidth: strokeWidth,
    d: "M12.5 11.6L19.1 5l.9.9-6.6 6.6 6.6 6.6-.9.9-6.6-6.6L5.9 20l-.9-.9 6.6-6.6L5 5.9l.9-.9 6.6 6.6z",
    fill: color,
    stroke: color
  }));
};

Close.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  bold: PropTypes.bool
};
Close.defaultProps = {
  color: colors.bnnvara.base.white,
  size: 25,
  bold: false
};
export default Close;